import { useRemoteBool } from '@mrkt/features/RemoteConfig';

export function useArtistGraphqlBool() {
  return useRemoteBool('use-artist-graphql');
}
